import { createSlice } from "@reduxjs/toolkit";
import RightBarInitialState from "../Variables/RightBarState";

const RightBarSlice = createSlice({
  name: "rightBar",
  initialState: RightBarInitialState,
  reducers: {
    updateToggleState: (state, action) => {
      state.toggleState = action.payload;
    },
  },
});

export const { updateToggleState } = RightBarSlice.actions;
export default RightBarSlice.reducer;
